import { render, staticRenderFns } from "./ItemFilterPrice.vue?vue&type=template&id=60aef3ba&"
import script from "./ItemFilterPrice.vue?vue&type=script&lang=js&"
export * from "./ItemFilterPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/plugin-ceres/plugin-ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60aef3ba')) {
      api.createRecord('60aef3ba', component.options)
    } else {
      api.reload('60aef3ba', component.options)
    }
    module.hot.accept("./ItemFilterPrice.vue?vue&type=template&id=60aef3ba&", function () {
      api.rerender('60aef3ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/itemList/filter/ItemFilterPrice.vue"
export default component.exports